module.exports = __webpack_public_path__ + "img/BalanceSheet.8ca8d3eb.png";